import { ProblemToken } from '../shared/problem-token'
export class WeekRow{
  private _days:Array<WeekDay>=[]; 
  constructor(private _weekNum:number){
  }

  addDay(_date:Date){
     this.days.push(new WeekDay(_date));
  }

  addProblem(_date:Date,_problem:ProblemToken){
    var _selDayIndex = this.days.findIndex((_day:WeekDay) => {
            var _selDate = _day.weekDate;
            return ((_selDate.getDate() == _date.getDate()) &&
                    (_selDate.getMonth() == _date.getMonth()) &&
                    (_selDate.getFullYear() == _date.getFullYear())); 
            });
    if(_selDayIndex < 0){
        this.addDay(_date);
        _selDayIndex = this.days.length - 1;
    }

    this.days[_selDayIndex].addProblem(_problem);
  }

  get weekNumber():number{
      return this._weekNum;
  }
    
  get days():Array<WeekDay>{
    return this._days;
  }


}

export class WeekDay{
    private _problems:Array<ProblemToken> = []
    constructor(private _date:Date){

    }
    addProblem(_prob:ProblemToken){
        this._problems.push(_prob);
    }
    get weekDate():Date{
        return this._date;
    }
    get problems():Array<ProblemToken>{
        return this._problems;
    }
}



export class GenWeekRow{
    private _days:Array<GenWeekDay>=[]; 
    constructor(private _weekNum:number){
    }
  
    addDay(_date:Date){
       this.days.push(new GenWeekDay(_date));
    }
  
    get weekNumber():number{
        return this._weekNum;
    }
      
    get days():Array<GenWeekDay>{
      return this._days;
    }
  
  
  }
  
  export class GenWeekDay{
      constructor(private _date:Date){
      }
      get weekDate():Date{
          return this._date;
      }
      
  }
  
  